import {IObjectData, TDataSourceType, TRouteId} from "../../../index";
import {TSyncfield_User} from "../../../constants/Syncfields";
import {getDataSourceTypesFromObject, getRawSyncFieldValue} from "../../../util/misc";

const TranslationKeyPrefix = 'view.objectdetail.user'

type TCardName =
    'account' |
    'contactinformation' |
    // not used for now
    // 'employment.edu' |
    'employment.hr' |
    'enrollment' |
    'positions.hr' |
    'positions.edu' |
    'personal'

export namespace nsUserSyncfields {

    export interface ICard {
        heading: `${typeof TranslationKeyPrefix}.${TCardName}`,
        description: `${typeof TranslationKeyPrefix}.${TCardName}.description`,
        subheading?: [TSyncfield_User, TSyncfield_User]
        datasourcetype?: TDataSourceType
        identitytype?: 'Staff' | 'Learner'
        syncfields: TSyncfield_User[]
        optional?: TSyncfield_User[]
    }

    export const def: Partial<Record<TRouteId, ICard[]>> = {
        'personal': [
            {
                heading: `${TranslationKeyPrefix}.personal`,
                description: `${TranslationKeyPrefix}.personal.description`,
                syncfields: [
                    'GivenName',
                    'MiddleName',
                    'Surname',
                    'Birthdate',
                    'Socialsecuritynumber',
                ],
                optional: [
                    'MiddleName'
                ]
            }, {
                heading: `${TranslationKeyPrefix}.contactinformation`,
                description: `${TranslationKeyPrefix}.contactinformation.description`,
                syncfields: [
                    'PrivateEmail',
                    'Email',
                    'Mail',
                    'PrivatePhone',
                    'TelephoneNumber',
                    'WorkPhone',
                    'Mobile',
                ],
            }, {
                heading: `${TranslationKeyPrefix}.account`,
                description: `${TranslationKeyPrefix}.account.description`,
                syncfields: [
                    'UserName',
                    'Upn',
                ],
            }
        ],
        'employment': [
            {
                heading: `${TranslationKeyPrefix}.employment.hr`,
                description: `${TranslationKeyPrefix}.employment.hr.description`,
                datasourcetype: 'hr',
                syncfields: [
                    'EmployeeNumber',
                    'Title',
                    'EmployeeStatusCode',
                    'WorkClassification',
                    'Start',
                    'Stop',
                ],
            },
            // not used for now
            // {
            //     heading: `${TranslationKeyPrefix}.employment.edu`,
            //     description: `${TranslationKeyPrefix}.employment.edu.description`,
            //     datasourcetype: 'edu',
            //     identitytype: 'Staff',
            //     syncfields: [
            //         'AeduPositionOrgName',
            //         'IdentityType',
            //         'AeduPositionStartDate',
            //         'AeduPositionEndDate',
            //         'AeduPositionName',
            //     ],
            // }
        ],
        'positions': [
            {
                heading: `${TranslationKeyPrefix}.positions.hr`,
                description: `${TranslationKeyPrefix}.positions.hr.description`,
                subheading: ['APositionCodeName', 'AUnitName'],
                datasourcetype: 'hr',
                syncfields: [
                    'APositionCodeId',
                    'APrimaryPosition',
                    'APositionCodeName',
                    'AmanualPosition',
                    'AWorkClassificationName',
                    'AUnitName',
                    'AUnitId',
                    'APositionManager',
                    'APositionPercentage',
                    'APositionTypeName',
                    'APositionTypeValue',
                    'APositionCodeCode',
                    'APositionStartDate',
                    'APositionEndDate',
                    'AAuthorizedPositionName',
                    'ALeaveType',
                    'ALeavePercentage',
                    'ALeaveFromDate',
                    'ALeaveToDate',
                    'ALeaveReason',
                ],
            },
            {
                heading: `${TranslationKeyPrefix}.positions.edu`,
                description: `${TranslationKeyPrefix}.positions.edu.description`,
                subheading: ['AeduPositionName', 'AeduPositionOrgName'],
                datasourcetype: 'edu',
                syncfields: [
                    'AeduPositionName',
                    'AeduPositionOrgName',
                    'AeduPositionOrgId',
                    'AeduPositionPercentage',
                    'AeduPositionStartDate',
                    'AeduPositionEndDate',
                ],
            }
        ],
        'enrollment': [
            {
                heading: `${TranslationKeyPrefix}.enrollment`,
                description: `${TranslationKeyPrefix}.enrollment.description`,
                syncfields: [
                    "AenrollmentOrgName",
                    "AenrollmentOrgId",
                    "AenrollmentLevel",
                    "AenrollmentStartDate",
                    "AenrollmentEndDate",
                ],
            }
        ],
    }

    export function shouldShow(def: ICard, object: IObjectData): boolean {
        let a: boolean = true
        let b: boolean = true

        const userDataSourceTypes = getDataSourceTypesFromObject(object)

        if (def.datasourcetype) {
            a = userDataSourceTypes.includes(def.datasourcetype)
        }

        const identitytype = getRawSyncFieldValue('IdentityType', object.syncfields)
        if (identitytype) {
            switch (def.identitytype) {
                case "Staff":
                    b = identitytype.includes('Staff')
                    break
                case "Learner":
                    b = identitytype.includes('Learner')
                    break
            }
        }

        return a && b
    }

}